<template>
  <v-container fluid>
    <h1 class="mb-5">Rengiami dokumentai</h1>
    <v-sheet class="d-flex justify-start" color="transparent">
      <v-card
        flat
        style="width: 200px;"
        color="transparent"
        class="mr-5"
        v-if="!singleTab"
      >
        <v-card>
          <v-list dense>
            <v-list-item-group v-model="activeTab" color="primary" mandatory>
              <v-list-item
                v-for="(item, i) in tabItems"
                :key="i"
                @click="gotoTab(item)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-card>
      <v-card v-if="activeTab >= 0" width="100%" min-width="400px">
        <component
          :is="routeItems[activeRoute].component"
          class=""
          :single-tab="singleTab"
        ></component>
      </v-card>
    </v-sheet>
  </v-container>
</template>

<script>
import { authRoute } from './../../router/routeRole'
import PranesimasRengiami from './PranesimasRengiami'
import PranesimasRengiamiNEP from './PranesimasRengiamiNEP'

export default {
  name: 'PranesimasRengiamiTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Hipotekos / Įkeitimai',
          route: 'rengiamiDokumentaiHipoteka',
          component: PranesimasRengiami,
        },
        {
          title: 'Prašymai dėl juridinių faktų',
          route: 'rengiamiDokumentaiPrasymas',
          component: PranesimasRengiamiNEP,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter(item => {
        return !item.hide && authRoute(item.route)
      })
    },
    singleTab() {
      return this.tabItems.length === 1
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function(item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
